import React from 'react';
import classNames from 'classnames/bind';
// import HorizontalScroll from '../components/HorizontalScroll';

import { ScrollContainer } from '@beef/legacy-ui-kit';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * HOC for TabsList to enhance behavior with ScrollContainer
 * Takes two element array of [TabsList, TabsItem] components
 * @returns same array extended with context
 */

export default function withScrollContainer([WrappedTabsList, WrappedTabsItem]) {
  const ScrollableTabsList = (props) => {
    return (
      <ScrollContainer className={cx('container')}>
        <WrappedTabsList {...props} />
      </ScrollContainer>
    );
  };

  /**
   * Override component name by prepending `Scrollable~`
   * to make it look nice, for example: `ScrollableTabsList`
   */
  if (process.env.NODE_ENV !== 'production') {
    const WrappedComponentName = WrappedTabsList.displayName || WrappedTabsList.name || 'TabsList';
    ScrollableTabsList.displayName = `Scrollable${WrappedComponentName}`;
  }

  return [ScrollableTabsList, WrappedTabsItem];
}
